export default __webpack_public_path__ + "static/resources/policy/Кодекс_делового_поведения_и_этики_АКВААРТ.doc";